import { Directive, ElementRef, inject, NgZone, OnDestroy, OnInit } from "@angular/core";

/**
 * Publishes the element's content height as `--content-height`, so CSS can transition
 * `max-height` to the exact open height rather than a guessed cap. Watches the children, since
 * the element itself sits at 0 while collapsed, and reads its `scrollHeight`, which still counts
 * clipped content.
 */
@Directive({
    selector: "[appContentHeight]",
    standalone: true
})
export class ContentHeightDirective implements OnInit, OnDestroy {
    private readonly el: ElementRef<HTMLElement> = inject(ElementRef);
    private readonly zone = inject(NgZone);
    private observer?: ResizeObserver;

    ngOnInit(): void {
        const host = this.el.nativeElement;
        // Only writes a style property, so there's nothing for change detection to pick up.
        this.zone.runOutsideAngular(() => {
            const observer = new ResizeObserver(() =>
                host.style.setProperty("--content-height", `${host.scrollHeight}px`)
            );
            Array.from(host.children).forEach(child => observer.observe(child));
            this.observer = observer;
        });
    }

    ngOnDestroy(): void {
        this.observer?.disconnect();
    }
}
